import axios from 'axios';
let getProductListUrl = 'https://ov4kus6nna.execute-api.af-south-1.amazonaws.com/getproductlist/JHB'
let getStoreInfoUrl = 'https://ov4kus6nna.execute-api.af-south-1.amazonaws.com/getstoreinfo/JHB'
    
let jsonData = undefined;
let storeInfo = undefined;
const getSourceData = async () => {
    if(!jsonData){
        const storeName = window.location.hash?.replace("#","").trim();
        if(storeName) {
            getStoreInfoUrl = getStoreInfoUrl.replaceAll("JHB",storeName);
            getProductListUrl = getProductListUrl.replaceAll("JHB",storeName);
        }
        let productList = axios.get(getProductListUrl);
        storeInfo = axios.get(getStoreInfoUrl);
        const renameKeys = (data) => ({
            id: data._id,
            'Description': data.brfdesc_2,
            'Category': data.desc_5,
            'Branch Code': data.kdbpart_2,
            'Product code': data.partno_2,
            'Price (Ex VAT)': data.price_1,
            'Stock on hand': data.qty_0,
            'EDP Code': data.url_3,
        });
        productList = await productList;
        jsonData = productList.data.map(renameKeys);
        storeInfo = await storeInfo;
    }
    return {data: jsonData ,info: storeInfo.data[0] ?? {title: "Parts Clearance - National  ", address: "Contact Sales",email: "saleshub@autoboys.co.za",tel: "010 44 88 88 5"}}; 
};

export default getSourceData;